import React from "react";
import { Table, InputNumber, Button, Input } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export default function ServiceTable({
  items = [],
  handleNameChange,
  handleQtyChange,
  handleRemoveItem,
  handlePriceChange,
  firstColumnTitle = "Layanan",
}) {
  const showQtyColumn = items.some((item) => item.qty != null);

  const columns = [
    {
      title: firstColumnTitle,
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => {
        if (record.isEditable && handleNameChange) {
          return (
            <Input
              value={text}
              onChange={(val) => handleNameChange(index, val)}
              style={{ width: "100%" }}
            />
          );
        } else {
          return (
            <div>
              <div>{text}</div>
              {record.description && (
                <div style={{ fontSize: "11px", color: "#888" }}>
                  {record.description}
                </div>
              )}
            </div>
          );
        }
      },
    },
    ...(showQtyColumn
      ? [
          {
            title: "Jumlah",
            dataIndex: "qty",
            key: "qty",
            width: 150,
            render: (qty, record, index) => (
              <InputNumber
                value={qty}
                onChange={(value) => handleQtyChange(index, value)}
                min={1}
                style={{ width: "100%" }}
              />
            ),
          },
        ]
      : []),
    {
      title: "Harga Satuan (IDR)",
      dataIndex: "price",
      key: "price",
      align: "right",
      render: (price, record, index) => {
        if (record.isEditable && handlePriceChange) {
          return (
            <InputNumber
              value={price}
              onChange={(val) => handlePriceChange(index, val)}
              formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              style={{ width: "100%" }}
            />
          );
        }
        return Number(price).toLocaleString();
      },
    },
    {
      title: "Harga Sebelum Pajak (IDR)",
      dataIndex: "amountBeforeTax",
      key: "amountBeforeTax",
      align: "right",
      render: (amountBeforeTax) =>
        amountBeforeTax != null
          ? Number(amountBeforeTax).toLocaleString()
          : "-",
    },
    {
      title: "Tax Rate (%)",
      dataIndex: "taxRate",
      key: "taxRate",
      align: "right",
      render: (taxRate) => (taxRate != null ? `${taxRate}%` : "-"),
    },
    {
      title: "Jumlah Pajak (IDR)",
      dataIndex: "taxAmount",
      key: "taxAmount",
      align: "right",
      render: (taxAmount) =>
        taxAmount != null ? Number(taxAmount).toLocaleString() : "-",
    },
    {
      title: "Subtotal (IDR)",
      dataIndex: "total",
      key: "total",
      align: "right",
      render: (total) => `Rp ${Number(total).toLocaleString()}`,
    },
    {
      title: "",
      key: "action",
      width: 50,
      render: (text, record, index) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => handleRemoveItem(index)}
        />
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      rowKey={(record, index) => index}
      pagination={false}
      locale={{
        emptyText: "Belum ada layanan dipilih",
      }}
      size="small"
      bordered
    />
  );
}
